
import React, { Component } from 'react';
import { Container, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import DiscreteSlider from '../global_layout/sliderInput';


class SideBarVisa extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return ( 
            <Container>
            <br />
          <center><span className="side-bar-txt header-sd-br">Recherche Acvancée</span></center>
          <br />
          <div>
          <span className="px-3 side-bar-txt">Choisir une destination</span>
          <UncontrolledDropdown nav inNavbar className="px-3">
           <DropdownToggle className="Advanced-btn-ser txt-sdBar-visa" style={{width:"100%",backgroundColor:"white",color:"#707070",textAlign:"left",borderRadius:"10px"}}>
           Turquie
             <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big"/>
           </DropdownToggle>
           <DropdownMenu right className="full-width">
                   <DropdownItem name="destination">Algeriee</DropdownItem>
                   <DropdownItem name="destination">Italia</DropdownItem>
                   <DropdownItem name="destination">France</DropdownItem>
                 </DropdownMenu>
         </UncontrolledDropdown>
         </div>

         <div  className="px-3">
          <span className="side-bar-txt">Dates de Départ/Retour prévus</span>
          <UncontrolledDropdown nav inNavbar>
           <DropdownToggle  className="Advanced-btn-ser txt-sdBar-visa" style={{width:"100%",backgroundColor:"white",color:"#707070",textAlign:"left",borderRadius:"10px"}}>
           21/07/2021 - 11/08/2021
           <img style={{width:"20px",marginTop:"3px"}} src="/imgs/ghurfatiFilter/calendar_icn.svg" alt="" id="arrow-parcourir-big"/>
           </DropdownToggle>
           <DropdownMenu right className="full-width">
                   <DropdownItem name="destination">Algeriee</DropdownItem>
                   <DropdownItem name="destination">Italia</DropdownItem>
                   <DropdownItem name="destination">France</DropdownItem>
                 </DropdownMenu>
         </UncontrolledDropdown>
         </div>


         <div  className="px-3 my-1">
          <UncontrolledDropdown nav inNavbar>
           <DropdownToggle className="Advanced-btn-ser txt-sdBar-visa" style={{width:"100%",backgroundColor:"white",color:"#707070",textAlign:"left",borderRadius:"10px"}}>
           2 adultes
             <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big"/>
           </DropdownToggle>
           <DropdownMenu right className="full-width">
                   <DropdownItem name="destination">Algeriee</DropdownItem>
                   <DropdownItem name="destination">Italia</DropdownItem>
                   <DropdownItem name="destination">France</DropdownItem>
                 </DropdownMenu>
         </UncontrolledDropdown>
         </div>

         <div  className="px-3">
          <UncontrolledDropdown nav inNavbar>
           <DropdownToggle id="destination" className="Advanced-btn-ser txt-sdBar-visa" style={{width:"100%",backgroundColor:"white",color:"#37296a",textAlign:"left",borderRadius:"10px"}}>
            0 enfant
             <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big"/>
           </DropdownToggle>
           <DropdownMenu right className="full-width">
                   <DropdownItem name="destination">Algeriee</DropdownItem>
                   <DropdownItem name="destination">Italia</DropdownItem>
                   <DropdownItem name="destination">France</DropdownItem>
                 </DropdownMenu>
         </UncontrolledDropdown>
         </div>

         <br /> <br />
         <div className="pl-4 pr-4">
         <span className="side-bar-bdgt">Votre budget</span>
         <DiscreteSlider/>
         </div>

         <br />

         <div  className="px-3">
          <span className="side-bar-txt">Localisation de l'agence</span>
          <UncontrolledDropdown direction="up" nav inNavbar>
           <DropdownToggle  className="Advanced-btn-ser txt-sdBar-visa" style={{width:"100%",backgroundColor:"white",color:"#707070",textAlign:"left",borderRadius:"10px"}}>
           Alger
           <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big"/>
           </DropdownToggle>
           <DropdownMenu right className="full-width">
                   <DropdownItem name="destination">Algeriee</DropdownItem>
                   <DropdownItem name="destination">Italia</DropdownItem>
                   <DropdownItem name="destination">France</DropdownItem>
                 </DropdownMenu>
         </UncontrolledDropdown>
         </div>
         
          </Container>
         );
    }
}
 
export default SideBarVisa;